import { propsFactory } from '@components/utils';

import type { PropType } from 'vue';

export const makeWideProps = propsFactory(
  {
    /**
     * Удаляет max-width по умолчанию и растягивает сетку на всю ширину контейнера
     */
    wide: {
      type: Boolean as PropType<boolean>,
      default: false
    }
  },
  'wide'
);
